var render, staticRenderFns
import script from "./BaseButton.vue?vue&type=script&functional=true&lang=js&"
export * from "./BaseButton.vue?vue&type=script&functional=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports